import axios from 'axios';

const baseURL = process.env.REACT_APP_DEV_SERVER_URL;

export const getCategoryTickets = async (accessToken, query) => {
  let url = baseURL + `/common/ticket_by_category`;
  if (query) {
    url += query;
  }
  const options = {
    headers: {
      'content-type': 'application/json',
      'x-access-token': accessToken,
    },
    timeout: 30000,
    responseType: 'json',
    responseEncoding: 'utf8',
  };
  const response = await axios.get(url, options);
  return response.data;
};

export const getTicketDetail = async (accessToken, id, query) => {
  let url = baseURL + `/common/ticket/${id}`;
  if (query) {
    url += query;
  }
  const options = {
    headers: {
      'content-type': 'application/json',
      'x-access-token': accessToken,
    },
    timeout: 30000,
    responseType: 'json',
    responseEncoding: 'utf8',
  };
  const response = await axios.get(url, options);
  return response.data;
};
